"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * tries assigning `from` to `to`.
 * If assignment is possible,
 * the return type is the resulting type.
 * If assignment is not possible,
 * the return type is `never`.
 */
function tryAssign(from, to) { return from; }
exports.tryAssign = tryAssign;
//# sourceMappingURL=tryAssign.js.map